(() => {
  'use strict';
  function initSearch() {
    const dialog = document.querySelector('[data-qs-search-dialog]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const input = dialog.querySelector('input[type="search"]');
    const results = dialog.querySelector('#qs-search-results');
    const defaults = dialog.querySelector('[data-qs-search-default]');
    const status = dialog.querySelector('#qs-search-status');
    const clear = dialog.querySelector('[data-qs-search-clear]');
    const all = dialog.querySelector('[data-qs-search-all]');
    let timer, controller, requestId = 0, opener;
    const root = window.Shopify?.routes?.root || JSON.parse(document.getElementById('qs-config')?.textContent || '{}').root || '/';
    function invalidate() { clearTimeout(timer); controller?.abort(); requestId++; }
    function reset() {
      invalidate(); results.replaceChildren(); results.hidden = true;
      results.setAttribute('aria-busy', 'false'); defaults.hidden = false;
      clear.hidden = true; all.hidden = true; status.textContent = '';
    }
    async function search(query) {
      const id = ++requestId;
      controller?.abort(); controller = new AbortController();
      defaults.hidden = true; results.hidden = false; all.hidden = false; dialog.querySelector('.qs-search-scroll').scrollTop = 0;
      results.setAttribute('aria-busy', 'true'); status.textContent = 'Buscando seu Quick…';
      const url = new URL(root + 'search/suggest', location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('section_id', 'qs-search-results');
      url.searchParams.set('resources[type]', 'product,page');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,body');
      try {
        const response = await fetch(url, {signal: controller.signal, cache: 'no-store', headers: {Accept: 'text/html'}});
        if (!response.ok) throw new Error('Search unavailable');
        const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = documentResult.querySelector('.qs-predictive-content');
        if (!content) throw new Error('Search response missing');
        if (id !== requestId || input.value.trim() !== query) return;
        results.replaceChildren(content);
        status.textContent = content.querySelector('[data-qs-search-count]')?.textContent.trim() || 'Busca concluída.';
      } catch (error) {
        if (error.name === 'AbortError' || id !== requestId) return;
        results.replaceChildren();
        status.textContent = 'A busca rápida está indisponível. Use “Ver todos os resultados” para continuar.';
      } finally {
        if (id === requestId) results.setAttribute('aria-busy', 'false');
      }
    }
    function schedule() {
      invalidate(); const query = input.value.trim();
      clear.hidden = !query;
      if (!query) { reset(); return; }
      timer = setTimeout(() => search(query), 230);
    }
    input.addEventListener('input', schedule);
    clear.addEventListener('click', () => { input.value = ''; reset(); input.focus(); });
    dialog.querySelector('[data-qs-search-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { invalidate(); opener?.focus(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.querySelectorAll('[data-qs-search-query]').forEach(button => button.addEventListener('click', () => {
      input.value = button.dataset.qsSearchQuery; schedule(); input.focus();
    }));
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-qs-search-open]');
      if (!trigger || typeof dialog.showModal !== 'function') return;
      event.preventDefault(); opener = trigger;
      const menu = document.querySelector('.qs-mobile-menu'); if (menu) menu.open = false;
      const cart = document.getElementById('qs-cart'); if (cart?.open) cart.close();
      if (!dialog.open) dialog.showModal(); dialog.querySelector('.qs-search-scroll').scrollTop = 0; if (input.value.trim()) schedule(); else reset();
      input.focus();
    });
    dialog.querySelector('form').addEventListener('submit', event => {
      if (!input.value.trim()) { event.preventDefault(); input.focus(); }
    });
  }
  initSearch();
  document.addEventListener('shopify:section:load', initSearch);
})();


